export default function NotFound() {
  return <div>This is NOT FOUND PAGE</div>;
}
